import React from 'react';
import { useParams } from 'react-router';
import Wrapper from '../Wrapper';
import FeatureFormContainer from './FeatureFormContainer';

function FeatureFormWrapper(props) {
  const { feature } = useParams();

  return (
    <Wrapper>
      <FeatureFormContainer feature={feature} {...props} />
    </Wrapper>
  );
}

export default FeatureFormWrapper;
